// enums
import { RosterPlanModeEnum } from '../RosterPlan.enums';

// types
import type {
  RosterPlanModeLayout,
  RosterPlanSwitchableMode
} from '../RosterPlan.types';

/**
 * What the screen shows in a mode, after the Dojo features' `handleModeChange`.
 *
 * View and plan show the same grids with the same columns: Dojo swaps the open requests grid for a
 * plan-mode variant, but both build the same column set and differ only in editors, selection and
 * the add-row button — actions, which arrive with features 3 to 5 of #2498.
 *
 * Changes after publication removes both grids (`EmployeesGridFeature`, `RequestsGridFeature`) and
 * hides the period buttons (`.CHANGES_AFTER_PUBLICATION` in `RosterWidget.less`). Its own grid is
 * feature 7, so for now the screen shows a placeholder in their place.
 *
 * Plan actions are plan mode's alone. None of Dojo's is ported yet; the first are the React-only
 * automatic rostering actions — generating writes a base plan, and the explanation is about the plan
 * on screen — and the stamping and editing actions of features 3 to 5 join them.
 */
export const getRosterPlanModeLayout = (
  mode: RosterPlanSwitchableMode
): RosterPlanModeLayout => {
  const isChangesAfterPublication =
    mode === RosterPlanModeEnum.ChangesAfterPublication;

  return {
    showsRosterGrids: !isChangesAfterPublication,
    showsPeriodActions: !isChangesAfterPublication,
    showsPlanActions: mode === RosterPlanModeEnum.Plan
  };
};
